module.exports = __webpack_public_path__ + "static/media/celular.66394194.jpeg";